export default __webpack_public_path__ + "assets/images/3fa20cfe965c12941dc1c51af89c6afd.svg";